
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swap/[[...mints]]",
      function () {
        return require("private-next-pages/swap/[[...mints]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swap/[[...mints]]"])
      });
    }
  